import React, { useState, useEffect } from "react";
import { FaHome, FaUsers, FaBuilding, FaUser, FaCog, FaSignInAlt, FaUserPlus, FaExclamationTriangle } from 'react-icons/fa';
import './Dashboard.css';
import '../Responsive.css'

import { Link, Redirect, useParams } from "react-router-dom"
import New_cut from "./New_cut";
import Sheet_Inventory from "./Sheet_Inventory";
import ShippedData_Woodshop from "./ShippedData_Woodshop";
import Inprogress from "./Inprogress";
import Woodshop_Inventory from "./Woodshop_Inventory";
import Part_Layout_Woodshop from "./Part_Layout/Part_layout";
import Woodshop_Pivot from "./Pivot/Pivot";


const Sidebar_Woodshop = () => {
  const [newCut, setnewCut] = useState(false);
  const [SInventory, setSInventory] = useState(false);
  const [Partlayout, setPartlayout] = useState(false);
  const [ShippedWoodshop, setShippedWoodshop] = useState(false);
  const [FinishedParts, setFinishedParts] = useState(false);
  const [InProgressparts, setInProgressparts] = useState(false);
  const [Pivot, setPivot] = useState(false);
  const [Part_Layout, setPart_Layout] = useState(false);
  const [animation, setAnimation] = useState(true);
  var userName = (window.localStorage.getItem("Name").replace(/[{""}]/g, ""));
  const [Area, setArea] = useState("");
  var Stage = (window.localStorage.getItem("Stage"));
  const [rank_stage, setrank_stage] = useState(false);
  var Ranked = (window.localStorage.getItem("Rank"));

  useEffect(() => {
    if (Area == "Add New Cut") {
      setnewCut(true);
      setSInventory(false);
      setPartlayout(false);
      setShippedWoodshop(false);
      setPivot(false);
      setAnimation(false);
      setFinishedParts(false);
      setInProgressparts(false);
      setPart_Layout(false);
    }
    if (Area == "Sheet Inventory") {
      setnewCut(false);
      setSInventory(true);
      setPartlayout(false);
      setShippedWoodshop(false);
      setPivot(false);
      setAnimation(false);
      setInProgressparts(false);
      setFinishedParts(false);
      setPart_Layout(false);

    }
    if (Area == "Shipped Woodshop") {
      setnewCut(false);
      setSInventory(false);
      setPartlayout(false);
      setShippedWoodshop(true);
      setPivot(false);
      setAnimation(false);
      setInProgressparts(false);
      setFinishedParts(false);
      setPart_Layout(false);

    }
    if (Area == "Finished Parts") {
      setnewCut(false);
      setSInventory(false);
      setPartlayout(false);
      setShippedWoodshop(false);
      setPivot(false);
      setAnimation(false);
      setInProgressparts(false);
      setPart_Layout(false);
      setFinishedParts(true);

    } if (Area == "Unfinished Parts") {
      setnewCut(false);
      setSInventory(false);
      setPartlayout(false);
      setShippedWoodshop(false);
      setPivot(false);
      setAnimation(false);
      setInProgressparts(true);
      setFinishedParts(false);
      setPart_Layout(false);

    }
    if (Area == "Woodshop Pivot") {
      setnewCut(false);
      setSInventory(false);
      setPartlayout(false);
      setShippedWoodshop(false);
      setPivot(true);
      setAnimation(false);
      setInProgressparts(false);
      setFinishedParts(false);
      setPart_Layout(false);
    }
    if (Area == "Welcome") {
      setnewCut(false);
      setSInventory(false);
      setPartlayout(false);
      setShippedWoodshop(false);
      setPivot(false);
      setAnimation(true);
      setInProgressparts(false);
      setFinishedParts(false);
      setPart_Layout(false);

    }
    if (Area == "Part Layout") {
      setnewCut(false);
      setSInventory(false);
      setPartlayout(false);
      setShippedWoodshop(false);
      setPivot(false);
      setAnimation(false);
      setInProgressparts(false);
      setFinishedParts(false);
      setPart_Layout(true);

    }
    if (Area == "Open Orders") {
      setnewCut(false);
      setSInventory(false);
      setPartlayout(false);
      setShippedWoodshop(false);
      setPivot(false);
      setAnimation(false);
      setInProgressparts(false);
      setFinishedParts(false);
    }

  }, [Area]);
  const handleSelect = (selectedArea) => {
    setArea(selectedArea);

  };

  useEffect(() => {
    if (Ranked === '"Admin"' && Stage === '"2"') {
      setrank_stage(true);
    }
  }, [Ranked]);

  return (
    <div>
      <div class="row">
        <div >
          <div className="sidebar" id="supplychain-sidebar">
            <ul className="sidebar-nav">
              <li className="nav-item" id="mobileView" onClick={() => handleSelect('Add New Cut')}>
                <span>New Cut Entry</span>
              </li>
              <li className="nav-item" id="mobileView" onClick={() => handleSelect('Sheet Inventory')}>
                <span>Sheet Inventory</span>
              </li>
              <li className="nav-item" id="mobileView" onClick={() => handleSelect('Shipped Woodshop')}>
                <span>Shipped Woodshop</span>
              </li>
              <li className="nav-item" onClick={() => handleSelect('Unfinished Parts')}>
                <span>WIP</span>
              </li>
              <li className="nav-item" onClick={() => handleSelect('Finished Parts')}>
                <span>Woodshop Inventory</span>
              </li>
              <li className="nav-item" onClick={() => handleSelect('Woodshop Pivot')}>
                <span>Woodshop Pivot</span>
              </li>
              <li className="nav-item" onClick={() => handleSelect('Part Layout')}>
                <span>Part Layout</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="col" id='supply-section'>
          <br></br>
          <div class="row" >
            <div class="col-2" id="mobileView">
              <Link to="/rawmaterial">
              </Link>
            </div>
            <div class="col-2">
            </div>
            <div class="col-2">
            </div>
            <div class="col-4">
            </div>
            <div id="user-name-block" class="col-2">
              <span className="user-name">{userName}</span>
            </div>
            <h1 id="Supply_chain_title">{Area}</h1>
            {animation ? <div id="title_supplychain_box">
              <p id='supply_chain_title'>Woodshop</p>
            </div> : null}
            {newCut ? <New_cut /> : null}
            {SInventory ? <Sheet_Inventory /> : null}
            {ShippedWoodshop ? <ShippedData_Woodshop /> : null}
            {InProgressparts ? <Inprogress /> : null}
            {FinishedParts ? <Woodshop_Inventory /> : null}
            {Pivot ? <Woodshop_Pivot /> : null}
            {Part_Layout ? <Part_Layout_Woodshop /> : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar_Woodshop;
